import { ProviderType, UnitType } from "../enums";

const measures = {
  absoluteCredits: {
    displayName: "Absolute Credits",
    providerType: ProviderType.FOCUS,
    schemaName: "TERNARY_MULTI_CLOUD_FIELD/AbsoluteCredits",
    unit: UnitType.CURRENCY,
  },
  billedCost: {
    displayName: "Billed Cost",
    providerType: ProviderType.FOCUS,
    schemaName: "FOCUS_SPEC_FIELD/BilledCost",
    unit: UnitType.CURRENCY,
  },
  consumedQuantity: {
    displayName: "Consumed Quantity",
    providerType: ProviderType.FOCUS,
    schemaName: "FOCUS_SPEC_FIELD/ConsumedQuantity",
    unit: UnitType.STANDARD,
  },
  effectiveCost: {
    displayName: "Effective Cost",
    providerType: ProviderType.FOCUS,
    schemaName: "FOCUS_SPEC_FIELD/EffectiveCost",
    unit: UnitType.CURRENCY,
  },
} as const;

const dimensions = {
  ancestryNames: {
    displayName: "Ancestry Names",
    providerType: ProviderType.GCP,
    schemaName: "GCP_BILLING_EXPORT_FIELD/ancestry_names",
  },
  billingAccountID: {
    displayName: "Billing Account ID",
    providerType: ProviderType.FOCUS,
    schemaName: "FOCUS_SPEC_FIELD/BillingAccountId",
  },
  billingAccountName: {
    displayName: "Billing Account Name",
    providerType: ProviderType.FOCUS,
    schemaName: "FOCUS_SPEC_FIELD/BillingAccountName",
  },
  category: {
    displayName: "Service Category",
    providerType: ProviderType.FOCUS,
    schemaName: "FOCUS_SPEC_FIELD/ServiceCategory",
  },
  chargeDescription: {
    displayName: "Charge Description",
    providerType: ProviderType.FOCUS,
    schemaName: "FOCUS_SPEC_FIELD/ChargeDescription",
  },
  cloudID: {
    displayName: "Cloud ID",
    providerType: ProviderType.FOCUS,
    schemaName: "TERNARY_MULTI_CLOUD_FIELD/cloud_id",
  },
  cloudName: {
    displayName: "Cloud Name",
    providerType: ProviderType.FOCUS,
    schemaName: "TERNARY_MULTI_CLOUD_FIELD/cloud_name",
  },
  creditType: {
    displayName: "Credit Type",
    providerType: ProviderType.GCP,
    schemaName: "GCP_BILLING_EXPORT_FIELD/credits_type",
  },
  dataSource: {
    displayName: "Data Source",
    providerType: ProviderType.FOCUS,
    schemaName: "TERNARY_MULTI_CLOUD_FIELD/data_source",
  },
  invoiceMonth: {
    displayName: "Invoice Month",
    providerType: ProviderType.TERNARY,
    schemaName: "TERNARY_MULTI_CLOUD_FIELD/invoice_month",
  },
  providerType: {
    displayName: "Provider Name",
    providerType: ProviderType.FOCUS,
    schemaName: "FOCUS_SPEC_FIELD/ProviderName",
  },
  publisherName: {
    displayName: "Publisher Name",
    providerType: ProviderType.FOCUS,
    schemaName: "FOCUS_SPEC_FIELD/PublisherName",
  },
  resourceID: {
    displayName: "Resource ID",
    providerType: ProviderType.FOCUS,
    schemaName: "FOCUS_SPEC_FIELD/ResourceId",
  },
  serviceID: {
    displayName: "Service ID",
    providerType: ProviderType.FOCUS,
    schemaName: "TERNARY_MULTI_CLOUD_FIELD/ServiceId",
  },
  serviceName: {
    displayName: "Service Name",
    providerType: ProviderType.FOCUS,
    schemaName: "FOCUS_SPEC_FIELD/ServiceName",
  },
  subAccountID: {
    displayName: "Sub Account ID",
    providerType: ProviderType.FOCUS,
    schemaName: "FOCUS_SPEC_FIELD/SubAccountId",
  },
  subAccountName: {
    displayName: "Sub Account Name",
    providerType: ProviderType.FOCUS,
    schemaName: "FOCUS_SPEC_FIELD/SubAccountName",
  },
  subAccountNumber: {
    displayName: "Sub Account Number",
    providerType: ProviderType.FOCUS,
    schemaName: "TERNARY_MULTI_CLOUD_FIELD/SubAccountNumber",
  },
  userProductGroup: {
    displayName: "Product Group",
    providerType: ProviderType.AWS,
    schemaName: "AWS_USER_DEFINED_TAG/ProductGroup",
  },
} as const;

export const billingFocusSchema = { dimensions, measures } as const;
